import { useSelector } from "react-redux";
import { IRootState } from "../../..";
import CategoryCard from "./CategoryCard";
// import { settings } from "./SliderSettings";
import SwiperCore, { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/autoplay";

// import required modules
import { FreeMode, Autoplay } from "swiper";

SwiperCore.use([Navigation]);

const Category = () => {
  const home = useSelector((state: IRootState) => state.home.value);

  return (
    <div className="bg-mainBg bg-cover bg-primary/10 ">
      <div className="container mx-auto p-5 py-7 ">
        <div className="font-semibold text-base md:text-lg mb-3 block md:hidden">
          Our Categories
        </div>
        <Swiper
          freeMode={true}
          autoplay={{ delay: 3000 }}
          modules={[FreeMode, Autoplay]}
          className="mySwiper"
          breakpoints={{
            0: {
              slidesPerView: 3.2,
              spaceBetween: 5,
            },
            768: {
              slidesPerView: 6,
              spaceBetween: 15,
            },
          }}
        >
          {/* <div className="swiper-button-prev"></div>
          <div className="swiper-button-next"></div> */}
          {home.home.categories
            .filter((item) => item)
            .map((category, index) => (
              <SwiperSlide key={index}>
                <CategoryCard category={category} key={category.id} />
              </SwiperSlide>
            ))}
        </Swiper>
      </div>
    </div>
  );
};

export default Category;
